<template>
  <v-container fluid>
    <v-row>
      <v-col class="col-6">
        <h1>
          Quotation sources for {{ displayDate }}
        </h1>
      </v-col>
      <v-col class="col-6">
        <v-text-field
          placeholder="Sales person initials i.e. KB"
          style="margin-top: 0; padding-top: 0;"
          v-model="salesPerson"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12">
        <v-btn
          @click="exportTheData"
          class="float-right ml-1"
          small>Export</v-btn>
        <v-btn
          @click="showPicker = true, dates = []"
          class="float-right"
          small>View calendar</v-btn>
        <v-btn
          @click="changeMonth(2)"
          class="float-right ml-2 mr-2"
          small>Next Month</v-btn>
        <v-btn
          @click="changeMonth(1)"
          class="float-right"
          small>Prev Month</v-btn>
      </v-col>
    </v-row>
    <v-row v-if="showPicker">
      <v-col>
        <v-date-picker range v-model="dates"></v-date-picker>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-simple-table>
          <thead>
            <tr>
              <th class="text-left">No</th>
              <th class="text-left">Customer</th>
              <th class="text-left">Date</th>
              <th class="text-left">Source</th>
              <th class="text-left">Value</th>
              <th class="text-left">By</th>
              <th class="text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th class="text-left" colspan="7">Converted Quotations</th>
            </tr>
            <tr v-for="(quotation, index) in convertedQuotations" :key="`cq_${index}`">
              <td>{{ quotation.jobNumber }} {{ quotation.expired }}</td>
              <td>{{ quotation.customer }}</td>
              <td>{{ quotation.date | tinyDate }}</td>
              <td>{{ quotation.source }}</td>
              <td>
                <span v-if="quotation.value > quotation.minChargeAmount">
                  {{ quotation.value | priceInPounds | currency }}
                </span>
                <span v-else>
                  {{ quotation.minChargeAmount | priceInPounds | currency }}
                </span>
              </td>
              <td>{{ quotation.quotedByInitials }}</td>
              <td>
                <router-link custom v-slot="{ navigate }" :to="`/quotations/view/${quotation.id}`">
                  <v-btn
                    x-small
                    @click="navigate"
                    @keypress.enter="navigate"
                    role="link">
                    View
                  </v-btn>
                </router-link>
              </td>
            </tr>
            <tr>
              <th class="text-left" colspan="7">Pending Quotations</th>
            </tr>
            <tr v-for="(quotation, index) in pendingQuotations" :key="`q_${index}`">
              <td>{{ quotation.jobNumber }} {{ quotation.expired }}</td>
              <td>{{ quotation.customer }}</td>
              <td>{{ quotation.date | tinyDate }}</td>
              <td>{{ quotation.source }}</td>
              <td>
                <span v-if="quotation.value > quotation.minChargeAmount">
                  {{ quotation.value | priceInPounds | currency }}
                </span>
                <span v-else>
                  {{ quotation.minChargeAmount | priceInPounds | currency }}
                </span>
              </td>
              <td>{{ quotation.quotedByInitials }}</td>
              <td>
                <router-link custom v-slot="{ navigate }" :to="`/quotations/view/${quotation.id}`">
                  <v-btn
                    x-small
                    @click="navigate"
                    @keypress.enter="navigate"
                    role="link">
                    View
                  </v-btn>
                </router-link>
              </td>
            </tr>
            <tr>
              <th class="text-left" colspan="7">Lost Quotations</th>
            </tr>
            <tr v-for="(quotation, index) in lostQuotations" :key="`qt_${index}`">
              <td>{{ quotation.jobNumber }} {{ quotation.expired }}</td>
              <td>{{ quotation.customer }}</td>
              <td>{{ quotation.date | tinyDate }}</td>
              <td>{{ quotation.source }}</td>
              <td>
                <span v-if="quotation.value > quotation.minChargeAmount">
                  {{ quotation.value | priceInPounds | currency }}
                </span>
                <span v-else>
                  {{ quotation.minChargeAmount | priceInPounds | currency }}
                </span>
              </td>
              <td>{{ quotation.quotedByInitials }}</td>
              <td>
                <router-link custom v-slot="{ navigate }" :to="`/quotations/view/${quotation.id}`">
                  <v-btn
                    x-small
                    @click="navigate"
                    @keypress.enter="navigate"
                    role="link">
                    View
                  </v-btn>
                </router-link>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from '../../axios';

export default {
  name: 'ReportsQuotationSources',
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      dates: [],
      displayDate: '',
      showPicker: false,
      lostQuotations: [],
      convertedQuotations: [],
      pendingQuotations: [],
      salesPerson: '',
      month: 0,
      year: 0,
      monthDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    };
  },
  watch: {
    dates() {
      if (this.dates.length > 1) {
        this.showPicker = false;
        this.getQuotationSources();
      }
    },
    monthDate() {
      this.showPicker = false;
      this.updateMonth();
    },
    salesPerson() {
      if (this.salesPerson.length > 1) {
        this.getQuotationSources();
      }
    }
  },
  methods: {
    changeMonth(direction) {
      console.log(this.month);
      if (direction === 1) {
        if (this.month > 1) {
          this.month = parseInt(this.month) - 1;
        } else {
          this.month = 11;
          this.year = parseInt(this.year) - 1;
        }
      } else {
        if (this.month < 11) {
          this.month = parseInt(this.month) + 1;
        } else {
          this.month = 1;
          this.year = parseInt(this.year) + 1;
        }
      }
      console.log(this.month);
      this.getQuotationSources();
    },
    exportTheData() {
      axios.post(`/spreadsheets/quotationSources/${this.month}/${this.year}/${this.salesPerson}.json?token=${this.token}`, this.dates, {responseType:'blob'})
          .then((response) => {
            const href = URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', 'quotationSources.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          });
    },
    updateMonth() {
      const currentDate = new Date();
      this.month = (currentDate.getMonth() + 1);
      this.year = currentDate.getFullYear();
      this.getQuotationSources();
    },
    getQuotationSources() {
      axios.post(`/quotations/getQuotationSources/${this.month}/${this.year}/${this.salesPerson}.json?token=${this.token}`, this.dates)
      .then((response) => {
        this.lostQuotations = response.data.lostQuotations;
        this.convertedQuotations = response.data.convertedQuotations;
        this.pendingQuotations = response.data.pendingQuotations;
        this.month = response.data.month;
        this.year = response.data.year;
        this.displayDate = response.data.displayDate;
      });
    },
  },
  mounted() {
    this.updateMonth();
  },
};
</script>
